export class CoreInfoRequestDetailCreate {
  public CoreInfoRequestId?: number;
  public CoreInfoRequestReasonId?: number;
}

export class CoreInfoRequestDetailEdit {
  public Id?: number;
  public CoreInfoRequestId?: number;
  public CoreInfoRequestReasonId?: number;
}
